import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: '/',
        redirect: '/project/myProject'
    },
    {
        path: '/project',
        name: 'project',
        component: () => import('@/page/project/index.vue'),
        children: [{
            path: 'myProject',
            name: 'myProject',
            component: () => import('@/page/project/src/myProject.vue')
        },
        {
            path: 'newProject',
            name: 'newProject',
            component: () => import('@/page/project/src/newProject/index.vue')
        }]
    },
    {
        path: '/wlan',
        name: 'wlan',
        component: () => import('@/page/wlanPlanner/index.vue')
    },
    {
        path: '/addDrawing',
        name: 'addDrawing',
        component: () => import('@/page/drawing/addDrawing.vue')
    }
];

const router = new VueRouter({
    // mode: 'history',
    base: '/wlanPlanner',
    routes
});

export default router;
